var _circle, _g, _g2, _path, _path2, _g3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoReactionDistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 138,
    viewBox: "0 0 142 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 69,
    r: 69,
    fill: "url(#paint0_linear_11738_69956)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11738_69956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.706 11.8643H82.7157C81.7682 11.8643 81 12.6324 81 13.58V47.1057C81 48.0533 81.7682 48.8215 82.7157 48.8215H128.706C129.654 48.8215 130.422 48.0533 130.422 47.1057V13.58C130.422 12.6324 129.654 11.8643 128.706 11.8643Z",
    fill: "#5E6974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1092 47.772C98.0922 46.6736 98.8712 44.8906 100.368 44.8906H111.365C112.861 44.8906 113.64 46.6728 112.624 47.7715L107.128 53.7126C106.449 54.4466 105.289 54.4469 104.61 53.7132L99.1092 47.772Z",
    fill: "#5E6974"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11738_69956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.06 11H82.7285C81.7739 11 81 11.7739 81 12.7285V46.5027C81 47.4573 81.7739 48.2312 82.7285 48.2312H129.06C130.015 48.2312 130.789 47.4573 130.789 46.5027V12.7285C130.789 11.7739 130.015 11 129.06 11Z",
    fill: "#BDC3C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2452 48.4716C98.2206 47.365 99.0055 45.5688 100.513 45.5688H111.591C113.099 45.5688 113.884 47.3643 112.86 48.471L107.324 54.4562C106.64 55.1957 105.471 55.1959 104.787 54.4568L99.2452 48.4716Z",
    fill: "#BDC3C8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.591 37.6741C101.078 37.2031 100.675 36.5819 99.8879 36.5146C99.5876 36.4887 99.6963 36.2558 99.7274 36.0953C100.266 33.1863 100.804 30.2772 101.348 27.3681C101.389 27.1559 101.43 26.985 101.684 26.9126C104.112 26.2034 105.489 24.1795 107.197 22.5541C109.024 20.8149 109.93 18.7288 110.039 16.2545C110.07 15.5816 110.427 15.3487 111.043 15.3228C111.783 15.2918 112.451 15.623 112.606 16.1562C112.979 17.4762 113.258 18.8323 113.165 20.2041C113.087 21.3325 112.492 22.3315 112.151 23.3979C111.902 24.1795 111.566 24.93 111.265 25.7117C111.431 25.8877 111.674 25.8566 111.881 25.898C114.335 26.3587 116.794 26.8142 119.252 27.2749C120.288 27.4664 120.738 27.8598 120.754 28.5742C120.769 29.4645 120.158 30.2513 119.289 30.5049C119.087 30.5619 118.771 30.4169 118.693 30.7016C118.616 30.9915 118.963 31.0226 119.113 31.1727C119.889 31.9491 119.491 33.1759 118.326 33.7142C118.046 33.8437 117.581 33.6728 117.503 34.0352C117.441 34.3251 117.891 34.4027 118.057 34.646C118.642 35.4897 118.041 36.7476 116.866 37.084C116.716 37.1254 116.545 37.1099 116.405 37.172C116.266 37.2341 116.131 37.3014 116.338 37.5137C117.26 38.4713 117.042 39.5272 115.826 40.0966C115.707 40.1536 115.582 40.2105 115.463 40.2675C115.023 40.4797 114.563 40.3917 114.118 40.3089C110.261 39.5997 106.41 38.8802 102.559 38.1607C102.197 38.0934 101.834 38.0158 101.596 37.6897L101.591 37.6741Z",
    fill: "#F1F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5904 30.5047C91.932 28.6567 92.2892 26.8088 92.6153 24.9608C92.6826 24.583 92.7551 24.407 93.2158 24.5001C95.4675 24.9453 97.7192 25.3646 99.976 25.758C100.421 25.8356 100.457 26.0013 100.385 26.3947C99.681 30.1113 98.9874 33.8279 98.3093 37.5496C98.2264 38.0207 98.0711 38.1345 97.5949 38.0362C95.4157 37.6066 93.2261 37.1925 91.0365 36.8198C90.493 36.7266 90.4516 36.5247 90.5448 36.0485C90.9175 34.2057 91.2436 32.3578 91.5852 30.5047H91.5904Z",
    fill: "#F1F4F6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11738_69956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1193 43.0615H4.51353C3.20301 43.0615 2.14062 44.1239 2.14062 45.4344V91.801C2.14062 93.1116 3.20302 94.1739 4.51354 94.1739H68.1193C69.4298 94.1739 70.4922 93.1116 70.4922 91.801V45.4344C70.4922 44.1239 69.4298 43.0615 68.1193 43.0615Z",
    fill: "#5E6974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1857 94.505C25.7792 92.9859 26.8566 90.52 28.9269 90.52H44.1351C46.2048 90.52 47.2825 92.9848 45.877 94.5043L38.2764 102.721C37.3373 103.736 35.7327 103.736 34.7932 102.722L27.1857 94.505Z",
    fill: "#5E6974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6065 39H2.53935C1.1369 39 0 40.1369 0 41.5393V91.1582C0 92.5606 1.1369 93.6975 2.53934 93.6975H70.6065C72.009 93.6975 73.1459 92.5606 73.1459 91.1582V41.5393C73.1459 40.1369 72.009 39 70.6065 39Z",
    fill: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8029 94.0521C25.2977 92.4264 26.4507 89.7876 28.6662 89.7876H44.9411C47.1561 89.7876 48.3093 92.4253 46.8052 94.0513L38.6715 102.844C37.6666 103.931 35.9494 103.931 34.944 102.845L26.8029 94.0521Z",
    fill: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7739 69.9802C44.2985 78.5378 36.5662 82.3087 36.5662 82.3087C36.5662 82.3087 28.8466 78.5505 22.3713 69.9802C17.3687 63.3652 17.6227 53.0046 24.7709 50.77C32.681 48.2941 36.5662 60.191 36.5662 60.191C36.5662 60.191 40.5149 48.2053 48.3742 50.77C55.497 53.0935 55.7764 63.3652 50.7739 69.9802Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.869 113.404L133.077 110.227L125.058 107.124L121.793 98L118.61 106.896L110 110.227L118.799 113.633L121.793 122L124.869 113.404Z",
    fill: "#BDC3C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11738_69956",
    x1: 57.931,
    y1: -234.759,
    x2: 73,
    y2: 193.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11738_69956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.4221,
    height: 47.1402,
    fill: "white",
    transform: "translate(81 11.8643)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11738_69956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.7885,
    height: 47.4896,
    fill: "white",
    transform: "translate(81 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11738_69956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.1459,
    height: 69.7686,
    fill: "white",
    transform: "translate(0 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReactionDistribution);
export default __webpack_public_path__ + "static/media/no-reaction-distribution.eaa06ad459f3056ae0d8cc00f08d2388.svg";
export { ForwardRef as ReactComponent };